<template>
  <ListView
    modelName="SalesOrder"
    perm="sales.menu_sales_order"
    svg="icon_side_orders"     
    color="steelblue"
    :items.sync="items"
    :params.sync="params"
    title="menu_sales_order"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="SalesOrder"
    :gridCaptions="listCaptions"
    :gridWidths="listWidths"
    :onCreate="onCreate"
    :importQuery="importQuery"
    :exportQuery="exportQuery"
    @selected="onSelectedMain"
    :isLoading="isLoading"
    borderColor="#E35F71"
    backColor="#FFF1F3"    
    tourId="289820"
    :comparer="(a,b)=>a.orderNo == b.orderNo"
    :postAddHandler="submitBundleAddOrderItemRun"
    :popup="popup"        
  >
    <!-- 明細項目の配置 -->
    <GridItem :slot="listSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="salesOrderStatus"/></GridItem>
    <GridItem :slot="listSlots[1]" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.orderNo }}</GridItem>    
    <GridItem :slot="listSlots[2]" slot-scope="{ item, index }"><Workflow :item="item" :index="index" @updated="onWorkflow" :perm="$refs.mainList.perm+'.approve'"/></GridItem>  
    <GridItem :slot="listSlots[3]" slot-scope="{ item }">{{ item.orderDate | date }}</GridItem>
    <GridItem :slot="listSlots[4]" slot-scope="{ item }">{{ item.counterpart.name }}</GridItem>
    <GridItem :slot="listSlots[5]" slot-scope="{ item }">{{ item.requestDate | date }}</GridItem>
    <GridItem :slot="listSlots[6]" slot-scope="{ item }">{{ item.receiver?item.receiver.name:'' }}</GridItem> 
    <GridItem :slot="listSlots[7]" slot-scope="{ item }">{{ item.outputReceiverName }}</GridItem> 
    <GridItem :slot="listSlots[8]" slot-scope="{ item }">{{ item.currencyCode | currency }}</GridItem>
    <GridItem :slot="listSlots[9]" slot-scope="{ item }">{{ item.refNo }}</GridItem>
    <GridItem :slot="listSlots[10]" slot-scope="{ item }">{{ item.customerOrderNo }}</GridItem>
    <GridItem :slot="listSlots[11]" slot-scope="{ item }">{{ item.projectItem?item.projectItem.name:'' }}</GridItem>       
    <GridItem :slot="listSlots[12]" slot-scope="{ item }">{{ item.segmentId | segment }}</GridItem>
    <GridItem :slot="listSlots[13]" slot-scope="{ item }">{{ item.pic | userGroup }}</GridItem>
    <GridItem :slot="listSlots[14]" slot-scope="{ item }" :right="true">{{ item.dealAmountFC | amountFC(item.currencyCode)}}</GridItem>
    <GridItem :slot="listSlots[15]" slot-scope="{ item }">{{ ( item.counterpart ? item.counterpart.taxType : null ) | taxTypes }}</GridItem>
    <GridItem :slot="listSlots[16]" slot-scope="{ item }" :right="true">{{ item.advanceAmountFC | amountFC(item.currencyCode) }}</GridItem>
    <GridItem :slot="listSlots[17]" slot-scope="{ item }" :right="true">{{ item.advanceBalanceAmountFC | amountFC(item.currencyCode) }}</GridItem>
    <GridItem :slot="listSlots[18]" slot-scope="{ item }" :right="true">{{ item.advanceCurrentAmountFC | amountFC(item.currencyCode) }}</GridItem>
    <GridItem :slot="listSlots[19]" slot-scope="{ item }" :right="true">{{ item.advanceWriteoffPendingAmountFC | amountFC(item.currencyCode) }}</GridItem>
    <GridItem :slot="listSlots[20]" slot-scope="{ item }">{{ item.dueDate | date }}</GridItem>
    <GridItem :slot="listSlots[21]" slot-scope="{ item }">{{ item.importNo }}</GridItem>        
    <GridItem :slot="listSlots[22]" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[23]" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem :slot="listSlots[24]" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[25]" slot-scope="{ item }">{{ item.lastUpdatedBy | user  }}</GridItem>
    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView" :electronicBookMode="tenantSettings.electronicBookMode" ref="menuBar" :voucherImportQuery="salesOrderImportQuery" :getKeyValue="(obj)=>obj.orderNo" reportHtml="<p class='cx_dialog_html'>※特定得意先の専用帳票を簡単に出力することが可能です。<br>　詳細は<a href='https://support.s-flow.net/ja/articles/8159389-特定の得意先専用の見積書-納品書-請求書を簡単に出力したい' target='_blank'>こちら</a>をご参照ください。</p>">
        <template v-if="hasLicenseExport">
          <ListViewMenu title="入金処理" @click="showAdvanceReceiptDialog" />
        </template>
          <ListViewMenu title="一括発注処理"  @click="showCreatePurchaseOrderDialog(false,true)" tooltip="チェックされた複数の受注に対してまとめて発注データを作成します。発注先ごとに発注伝票が作成されます。詳細は<a href='https://support.s-flow.net/ja/articles/6880885#h_2536219c47' target='_blank'>こちら</a>"/>
          <ListViewMenu title="一括出荷処理"  @click="showShippingInstructionDialog(false,true)" tooltip="選択された伝票に対して出荷処理を実施します。"/>
          <ListViewMenu title="定期出荷処理"  @click="showRegularlyDeliveryDialog" tooltip="選択された伝票の棚卸対象外商品について、定期的な複数の出荷伝票を作成します。"/>
          <ListViewMenu slot="report" title="得意先指定帳票出力"  @click="showCustomerReport" tooltip="【得意先】の【受注一覧指定帳票】で指定された帳票を出力します。詳細は<a href='https://support.s-flow.net/ja/articles/8159389' target='_blank'>サポートサイト</a>をご確認ください。"/>
          <ListViewMenu slot="mail" title="得意先指定帳票送信"  @click="showCustomerReport(true)" tooltip="【得意先】の【受注一覧指定帳票】で指定された帳票をメール送信します。詳細は<a href='https://support.s-flow.net/ja/articles/8159389' target='_blank'>サポートサイト</a>をご確認ください。"/>
      </ListViewMenuBar>
    </template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView" :tabs="['検索条件','取引先区分','予備項目']">
        <FilterBox title="受注番号" :value.sync="params.orderNo" @click="handler" />
        <FilterBox title="受注管理番号" :value.sync="params.refNo" @click="handler" />
        <FilterBox title="顧客注文番号" :value.sync="params.customerOrderNo" @click="handler" />       
        <FilterBox title="備考" :value.sync="params.description" @click="handler" />
        <FilterBox title="得意先名称" :value.sync="params.counterpartName" @click="handler"/>
        <FilterBox title="納入先名称" :value.sync="params.receiverName" @click="handler" tooltip='納入先詳細タブの納入先名称を部分一致で検索できます。' />
        <AtcCounterpart title="得意先" :value.sync="params.counterpart" :needsCustomer="true" @changed="handler"/>
        <AtcCounterpart title="納入先" :value.sync="params.receiver" :needsCustomer="true" :needsReceiver="true" @changed="handler" />
        <AtcProjectItem title="案件" :value.sync="params.projectItem" @changed="handler"/>          
        <AtcSegment title="部門" :value.sync="params.segment" @changed="handler" />
        <AutoComplete title="担当者" :value.sync="params.pic" list="user" @changed="handler" />
        <AutoComplete title="取引通貨"  :value.sync="params.currencyCode" list="currency" @changed="handler" v-if="hasLicenseCurrency" />         
        <Calendar title="受注日(From)" :value.sync="params.orderDateFrom" :deletable="true" @changed="handler" :autoEntry="true" :dateFlag.sync="params.orderDateFromFlag"/>
        <Calendar title="受注日(To)" :value.sync="params.orderDateTo" :deletable="true" @changed="handler" :autoEntry="true" :dateFlag.sync="params.orderDateToFlag"/>
        <Calendar title="希望納期(From)" :value.sync="params.requestDateFrom" :deletable="true" @changed="handler" :autoEntry="true" :dateFlag.sync="params.requestDateFromFlag"/>
        <Calendar title="希望納期(To)" :value.sync="params.requestDateTo" :deletable="true" @changed="handler" :autoEntry="true" :dateFlag.sync="params.requestDateToFlag"/>
        <FilterBox title="受注金額(From)" :value.sync="params.dealAmountFcFrom" :isNumber="true" @click="handler" />
        <FilterBox title="受注金額(To)" :value.sync="params.dealAmountFcTo" :isNumber="true" @click="handler" />
        <Calendar title="次回清算日" :value.sync="params.nextSettlementDate" :deletable="true" @changed="handler" :autoEntry="true" :dateFlag.sync="params.nextSettlementFlag"/>        
        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
        <!-- <ComboBox title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> -->
        <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> 
        <ComboBox title="状態" :value.sync="params.state" :list="hasLicenseCurrency ? 'salesOrderStatus' : 'salesOrderStatusNoLicenseCurrency'" @changed="handler" />
        <ComboBox slot="tab1" title="category_1" :value.sync="params.category1" list="category_1" @changed="handler" />
        <ComboBox slot="tab1" title="category_2" :value.sync="params.category2" list="category_2" @changed="handler" />
        <ComboBox slot="tab1" title="category_3" :value.sync="params.category3" list="category_3" @changed="handler" />
        <ComboBox slot="tab1" title="category_4" :value.sync="params.category4" list="category_4" @changed="handler" />
        <ComboBox slot="tab1" title="category_5" :value.sync="params.category5" list="category_5" @changed="handler" />
        <ComboBox slot="tab1" title="category_6" :value.sync="params.category6" list="category_6" @changed="handler" />

        <FilterBox slot="tab2" title="voucher_text1" :value.sync="params.reserveText1" @click="handler"   />
        <FilterBox slot="tab2" title="voucher_text2" :value.sync="params.reserveText2" @click="handler" />
        <FilterBox slot="tab2" title="voucher_text3" :value.sync="params.reserveText3" @click="handler" />
        <FilterBox slot="tab2" title="voucher_text4" :value.sync="params.reserveText4" @click="handler" />
        <FilterBox slot="tab2" title="voucher_text5" :value.sync="params.reserveText5" @click="handler" />
        <FilterBox slot="tab2" title="voucher_text6" :value.sync="params.reserveText6" @click="handler" />
        <ComboBox slot="tab2" title="voucher_list1" :value.sync="params.reserveList1" list="category_31" @changed="handler" />
        <ComboBox slot="tab2" title="voucher_list2" :value.sync="params.reserveList2" list="category_32" @changed="handler" />
        <ComboBox slot="tab2" title="voucher_list3" :value.sync="params.reserveList3" list="category_33" @changed="handler" />         
        <Calendar slot="tab2" title="voucher_date1|(From)" :value.sync="params.reserveDate1From" :deletable="true" @changed="handler"/>
        <Calendar slot="tab2" title="voucher_date1|(To)" :value.sync="params.reserveDate1To" :deletable="true" @changed="handler" />
        <Calendar slot="tab2" title="voucher_date2|(From)" :value.sync="params.reserveDate2From" :deletable="true" @changed="handler" />
        <Calendar slot="tab2" title="voucher_date2|(To)" :value.sync="params.reserveDate2To" :deletable="true" @changed="handler" />
        <Calendar slot="tab2" title="voucher_date3|(From)" :value.sync="params.reserveDate3From" :deletable="true" @changed="handler"/>
        <Calendar slot="tab2" title="voucher_date3|(To)" :value.sync="params.reserveDate3To" :deletable="true" @changed="handler" />     
        <FilterBox slot="tab2" title="voucher_memo1" :value.sync="params.reserveMemo1" @click="handler"/>
        <FilterBox slot="tab2" title="voucher_memo2" :value.sync="params.reserveMemo2" @click="handler"/>
        <FilterBox slot="tab2" title="voucher_memo3" :value.sync="params.reserveMemo3" @click="handler"/>   
      </Search>
    </template>
    <!-- フルサイズエディタの配置(ListView:fullSizeEditor="true"を指定) -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','受注明細','記載事項','納入先詳細','予備項目','前受金情報','ワークフロー','更新履歴','添付ファイル']" :tabVisibles="listView.isInsertMode ? tabVisiblesOnInsert: tabVisibles" :tabTooltips="[null,'受注番号に紐づいている【受注明細】を確認することができます。','任意に受注データに関わる詳細情報を編集できるタブです。','基本情報タブで選択した納入先の情報が編集できます。','任意にテキスト入力・区分の設定・日付設定を行えます｡項目名は【テナント設定】＞【取引先予備項目】から変更が可能です。内容は帳票に載せることができます。',null,null,null,null]">
        <!-- エディタ編集・機能ボタン -->
        <template slot="menu" slot-scope="{ item, editor}">
          <SplitButton class="button" @click="showDirectAccessDialg(item)" caption="関連伝票"  icon="account_tree" tooltip="関連する伝票へのリンクを表示します。">          
          <Button class="button" @click="showSalesOrderItems" caption="明細表示" :disabled="editor.isEdit || disabledShowItemButton" icon="arrow_downward" tooltip="選択した受注に紐づく【受注明細】の一覧を表示します。"/>
          <!-- <Button class="button" @click="showBundleAddOrderItemDialog" caption="明細の追加" :disabled="editor.isEdit || disabledAddItemButton(item)" icon="add" tooltip="選択した受注に紐づく【受注明細】を追加する事ができます。"/> -->
          <!-- <Button class="button" @click="showSkuBundleAddOrderItem" caption="明細SKUの追加" :disabled="editor.isEdit || disabledAddItemButton(item)" icon="add" tooltip="【SKU一覧】から【商品】に【SKU】を追加している場合、この機能からSKU別にまとめて明細を追加することができます。"/> -->
          <Button class="button" @click="showPurchaseOrderItems" caption="発注明細表示" :disabled="editor.isEdit || disabledShowReferenceItemButton" icon="arrow_forward" tooltip="選択した受注に紐づく【発注明細】の一覧を表示します。"/>
          <Button class="button" @click="showSalesDeliveryItems" caption="出荷明細表示" :disabled="editor.isEdit || disabledShowReferenceItemButton" icon="arrow_forward" tooltip="選択した受注に紐づく【出荷明細】の一覧を表示します。"/>       
          </SplitButton>
        </template>
        <template slot="menu_right" slot-scope="{item}">
          <Button class="button" @click="showShippingInstructionDialog(true)" caption="出荷処理" v-if="! disabledOrderItemFuncButton(item)" :perm="$refs.mainList.perm + '.process'" :disabled="$refs.salesOrderItems && $refs.salesOrderItems.isLoading" />                
          <Button class="button" @click="showCreatePurchaseOrderDialog(true)" caption="発注処理" v-if="! (disabledOrderItemFuncButton(item)  || item.isSubscription)" :perm="$refs.mainList.perm + '.process'" :disabled="$refs.salesOrderItems && $refs.salesOrderItems.isLoading" />                                  
        </template>
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">
              <TextBox title="受注番号" :value.sync="item.orderNo" :editor="editor" :enabled="false" tooltip="初回保存時に先頭に”SO”がつく番号が自動で付与されます。この番号は手動で変更することができません。"/>                               
              <Calendar title="受注日" :value.sync="item.orderDate" :editor="editor" :required="true" :enabled="isEditable(item.state)" tooltip="得意先から商品のオーダーを受けた日付を入力します。"/> 
              <AtcCounterpart title="得意先" :value.sync="item.counterpart" :editor="editor"  :needsCustomer="true" :required="true" :enabled="isEditable(item.state)" @update:value="onChangeCustomer(item, editor)" tooltip="受注を受けた得意先を選択します。【取引先一覧】の【取引先種別】が【得意先】になっているデータが選択できます。"/>
              <Calendar title="希望納期" :value.sync="item.requestDate" :editor="editor" :enabled="isEditable(item.state)" :deletable="true" tooltip="商品をオーダーした得意先が希望する納期を入力します。"/>
              <AtcCounterpart title="納入先" :value.sync="item.receiver" :editor="editor" :needsCustomer="true" :needsReceiver="true" :customer="item.counterpart" :enabled="isEditable(item.state)" :isDirectEditEnabled="false" @update:value="onChangeReceiver(item, editor)" tooltip="商品の出荷先を選択します。【得意先】に設定した得意先､または【取引先一覧】の【取引先種別】が【納入先】になっているデータが選択できます。"/>  
              <ComboBox title="取引通貨" v-if="hasLicenseCurrency" :value.sync="item.currencyCode" list="currency" :required="true" :editor="editor" :enabled="isEditable(item.state)" nullValue="" />                
              <NumericBox title="受注金額" :value.sync="item.dealAmountFC" :editor="editor" :enabled="false" :decimals="$api.decimals[item.currencyCode]" tooltip="【受注明細】に登録されている【単価】×【受注数量】の合計金額が表示されています。"/>                
              <TextBox title="税計算区分" :value="(item.counterpart ? item.counterpart.taxType : '') | taxTypes" :editor="editor" :enabled="false" tooltip="【得意先】に設定した得意先の【税計算区分】が表示されています。"/>
              <NumericBox title="粗利" :value.sync="orderGrossProfit" :editor="editor" :enabled="false" :decimals="calcUtil.GetCurrecyDecimal(item.currencyCode,$api)" tooltip="【受注明細】に表示されている【粗利】の合計金額が表示されています。税抜の金額です。"/>
              <TextBox title="顧客注文番号" :value.sync="item.customerOrderNo" :editor="editor" :enabled="isEditable(item.state)" length="30" tooltip="任意で登録する受注に対して顧客注文番号を入力することができます。"/>
            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">
              <AtcProjectItem title="案件" :value.sync="item.projectItem" :editor="editor"  :enabled="isEditable(item.state)"  tooltip="登録済み案件の選択、新規案件の作成が行えます。"/>
              <AtcSegment title="部門" :value.sync="item.segment" :editor="editor" :required="true" :enabled="isEditable(item.state)" tooltip="受注を受けた部門を選択します。【部門一覧】に登録したデータから選択することができます。"/>
              <AutoComplete title="担当者" :value.sync="item.pic" :editor="editor" list="user" :required="true" :enabled="isEditable(item.state)" tooltip="案件を担当する人を選択します。【ユーザー】のデータを選択することができます。"/>
              <TextBox title="受注管理番号" :value.sync="item.refNo" :editor="editor" :enabled="isEditable(item.state)" length="30" tooltip="任意で登録する受注に対して管理番号を入力することができます。"/>
              <!-- <CheckBox title="EC連携先" :value.sync="item.ecFlag" list="ecFlags" :editor="editor" :enabled="false"  tooltip="EC連携先を表示します。"    />                   -->
              <!-- <template v-if="hasLicenseCurrency">
                <TextBox title="取引通貨" :value="item.currencyCode | currency" :editor="editor" :enabled="false" />
              </template> -->
              <div class="cx_controls">
                <CheckBox title="サブスクリプション" :value.sync="item.isSubscription" list="subscriptionFlags" :editor="editor" :enabled="item.isCopyEdit==false && isEditable(item.state)"  tooltip="サブスクリプション(定期契約)を使用する場合に選択します。受注明細を追加する際に、契約開始日・契約完了日を指定して月次数量を登録できるようになります。※棚卸対象外の商品を使用します。発注処理は行えません。"    />  
                <Calendar title="次回清算日" :value.sync="item.nextSettlementDate"  :enabled="false" tooltip="サブスクリプションの次回清算日が表示されます。"/>               
              </div>


              <!-- <ComboBox title="状態" :value.sync="item.state" :editor="editor" list="salesOrderStatus" :enabled="false" />
              <ComboBox title="所有者" :value.sync="item.workflowHolder" list="userGroup" :editor="editor" :enabled="false" /> -->
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="受注データを最後に更新した日時が表示されています。"/>
              <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_salesOrder" :required="$api.perms.hasWorkflow('salesOrder')" :enabled="$api.perms.hasWorkflow('salesOrder') && $api.perms.isEntryStatus(item)" :nullValue="0" tooltip="受注時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【受注管理】になっているデータから選択ができます。"/>
              <TextBox title="状態" :value="$api.perms.getWorkflowStateLabel(item)" :enabled="false" tooltip="受注データの現在の状態が表示されており､確定や業務処理を行う事で変化します。"/>
            </template>
          </EditPanel>
        </template>
        <!-- 受注明細タブ -->
        <template slot="tab1" slot-scope="{ item, editor}" >
          <GrdVoucherItem :voucherNo="item.orderNo" :voucherType="voucherTypes.SalesOrder" :voucherItemType="voucherTypes.SalesOrderItem" ref="salesOrderItems" :showCheckBox="true" :comparer="(a,b)=>a.auditNo == b.auditNo" @afterVoucherNoChanged="afterVoucherNoChanged">
              <template slot="menu"  slot-scope="{parent}" >
              <SplitButton class="button" @click="showBundleAddOrderItemDialog"  :perm="$refs.mainList.perm + '.edit'"  caption="明細の追加" :disabled="(editor.owner.isAdding == false && editor.isEdit) || disabledAddItemButton(item) || ($refs.salesOrderItems && $refs.salesOrderItems.isLoading)" icon="add" tooltip="選択した受注に紐づく【受注明細】を追加する事ができます。">     
                <!--ドロップダウンに配置するボタンにiconを設定しないでください  -->
                <Button class="button" @click="showSkuBundleAddOrderItem"   :perm="$refs.mainList.perm + '.edit'"  caption="明細SKUの追加" v-if="$api.useStockFunction" :disabled="editor.isEdit || disabledAddItemButton(item) || ($refs.salesOrderItems && $refs.salesOrderItems.isLoading) || item.isSubscription" tooltip="【SKU一覧】から【商品】に【SKU】を追加している場合、この機能からSKU別にまとめて明細を追加することができます。"/>              
              </SplitButton>
              <Button class="button" @click="parent.onDelete().then(()=>$refs.mainList.reloadSelected())" :perm="$refs.mainList.perm + '.edit'"   caption="明細の削除" :disabled="editor.isEdit || disabledAddItemButton(item) || parent.isLoading" icon="delete"/>              
              <SplitButton class="button" @click="showShippingInstructionDialog"  :perm="$refs.mainList.perm + '.process'" caption="明細出荷処理" :disabled="editor.isEdit || disabledOrderItemFuncButton(item) || ($refs.salesOrderItems && $refs.salesOrderItems.isLoading)" tooltip="選択された【受注明細】に対して引当を行い、出荷伝票を作成します。在庫が不足している場合受注残として残ります。">                    
                <Button class="button" @click="showCreatePurchaseOrderDialog"  :perm="$refs.mainList.perm + '.process'" caption="明細発注処理" :disabled="editor.isEdit || disabledOrderItemFuncButton(item) || ($refs.salesOrderItems && $refs.salesOrderItems.isLoading) || item.isSubscription" tooltip="選択された【受注明細】に対応する発注伝票・発注明細伝票を作成します。"/>                                
              </SplitButton>    
              
              <SplitButton class="button" @click="showUpdateDeliveryDateDialog"  :perm="$refs.mainList.perm + '.process'" caption="納期更新" :disabled="editor.isEdit || ($refs.salesOrderItems && $refs.salesOrderItems.isLoading) || item.isSubscription" tooltip="【回答納期】と【出荷予定日】を一括で更新する事ができます。">
                <Button class="button" @click="showSubscriptionDateUpdateDialog"  :perm="$refs.mainList.perm + '.process'" caption="契約日付更新" :disabled="editor.isEdit  || ($refs.salesOrderItems && $refs.salesOrderItems.isLoading) || item.isSubscription == false" tooltip="選択された【受注明細】の契約開始日・契約完了日を更新します。"/>                    
                <Button class="button" @click="itemClosedQuery(true)"  :perm="$refs.mainList.perm + '.process'" caption="明細クローズ処理" :disabled="editor.isEdit || !enabledOrderItemCloseFuncButton(item) || ($refs.salesOrderItems && $refs.salesOrderItems.isLoading) || item.isSubscription" tooltip="選択された【受注明細】に対してクローズ処理を行い、受注残数量を0にします。受注残を出荷せずに受注伝票を完了させたい場合に利用します。"/>
                <Button class="button" @click="itemClosedQuery(false)"  :perm="$refs.mainList.perm + '.process'" caption="明細クローズ解除処理" :disabled="editor.isEdit || !enabledOrderItemCloseCancelFuncButton(item) || ($refs.salesOrderItems && $refs.salesOrderItems.isLoading) || item.isSubscription" tooltip="選択された【受注明細】に対してクローズ解除処理を行い、クローズ数量を0にします。クローズして完了させた伝票のクローズを解除したい場合に利用します。"/>
              </SplitButton>
              </template>  
              <PopupEditor slot="popupEditor" slot-scope="{parent}" v-model="parent.showEditor" title="受注明細" mode="editor" :isInsertMode="false" @closing="args=>{parent.replaceItem(args.target);$refs.mainList.reloadSelected();}">
                <SalesOrderItem slot-scope={popup} :popup="popup" :orderItemNo="parent.editItem ? parent.editItem.orderItemNo: null"/>
              </PopupEditor>                
          </GrdVoucherItem>
        </template>              
        <!-- 記載事項タブ -->
        <template slot="tab2" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 記載事項タブ 左側 -->
            <template slot="left">
              <TextBox title="決済条件" :value.sync="item.paymentTerm" :editor="editor" :enabled="isEditable(item.state)" length="50" tooltip="任意で決済に関わる情報を最大50文字まで入力でき、内容を帳票に載せることができます。この画面から入力した決済条件は出荷データに引継ぐことはできません。"/>
              <TextBox title="特記事項" :value.sync="item.remark" :editor="editor" :enabled="isEditableNoComplete(item.state)" length="200" rows="5" tooltip="任意で特記したい情報を最大200文字まで入力でき、内容を帳票に載せることができます。この画面から入力した内容は出荷データに引継ぐ事はできません。"/>
              <TextBox title="出荷指示" :value.sync="item.deliveryInstruction" :editor="editor" :enabled="isEditable(item.state)" length="200" rows="5" tooltip="任意で出荷に関わる指示を最大200文字まで入力でき、内容を帳票に載せることができます。情報を出荷の伝票に引継ぐことができます。"/>
            </template>
            <!-- 記載事項タブ 右側 -->
            <template slot="right">
              <TextBox title="備考" :value.sync="item.description" :editor="editor" :enabled="isEditableNoComplete(item.state)" length="200" rows="12" tooltip="任意で受注に関わる情報を最大200文字まで入力でき、内容を帳票に載せることができます。この画面から入力した内容は出荷データに引継ぐ事はできません。"/>
            </template>
          </EditPanel>
        </template>
        <!-- 納入先詳細タブ -->
        <template slot="tab3" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 納入先詳細タブ 左側 -->
            <template slot="left">
              <TextBox title="納入先名称" :editor="editor" :value.sync="item.outputReceiverName" :enabled="isEditable(item.state)" length="50" />
              <TextBox title="担当部署名" :editor="editor" :value.sync="item.outputReceiverPICSection" :enabled="isEditable(item.state)" length="50" />
              <TextBox title="担当者" :editor="editor" :value.sync="item.outputReceiverPIC" :enabled="isEditable(item.state)" length="30" />
              <TextBox title="敬称" :editor="editor" :value.sync="item.outputReceiverPICHonorificTitle" :enabled="isEditable(item.state)" length="5" />
              <TextBox title="電話番号" :editor="editor" :value.sync="item.outputReceiverTelNo" :enabled="isEditable(item.state)" length="20" />
              <TextBox title="FAX番号" :editor="editor" :value.sync="item.outputReceiverFaxNo" :enabled="isEditable(item.state)" length="20" />              
            </template>
            <!-- 納入先詳細タブ 右側 -->
            <template slot="right">
              <div style="display:flex;">
                <TextBox title="郵便番号" :editor="editor" :value.sync="item.outputReceiverPostalCode" :enabled="isEditable(item.state)" length="50"/>
                <Button class="button cx_itembutton" style="margin-left:10px"  @click="$api.getAddress(item.outputReceiverPostalCode).then(res => item.outputReceiverAddress1 = res)" caption="住所取得" :disabled="!isEditable(item.state) || editor.isEdit ==false" tooltip="郵便番号から住所を取得します"/>
              </div>
              <TextBox title="住所1" :editor="editor" :value.sync="item.outputReceiverAddress1" :enabled="isEditable(item.state)" length="50" />
              <TextBox title="住所2" :editor="editor" :value.sync="item.outputReceiverAddress2" :enabled="isEditable(item.state)" length="50" />
              <TextBox title="住所3" :editor="editor" :value.sync="item.outputReceiverAddress3" :enabled="isEditable(item.state)" length="50" />
            </template>
          </EditPanel>
        </template>        
        <!-- 予備項目タブ -->
        <template slot="tab4" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 予備項目タブ 左側 -->
            <template slot="left">
              <TextBox title="voucher_text1" :value.sync="item.reserveText1" :editor="editor" :enabled="isEditable(item.state)" length="50" />
              <TextBox title="voucher_text2" :value.sync="item.reserveText2" :editor="editor" :enabled="isEditable(item.state)" length="50" />
              <TextBox title="voucher_text3" :value.sync="item.reserveText3" :editor="editor" :enabled="isEditable(item.state)" length="50" />
              <TextBox title="voucher_text4" :value.sync="item.reserveText4" :editor="editor" :enabled="isEditable(item.state)" length="50" />
              <TextBox title="voucher_text5" :value.sync="item.reserveText5" :editor="editor" :enabled="isEditable(item.state)" length="50" />
              <TextBox title="voucher_text6" :value.sync="item.reserveText6" :editor="editor" :enabled="isEditable(item.state)" length="50" />
              <AutoComplete title="voucher_list1" :value.sync="item.reserveList1" :editor="editor" list="category_31" :enabled="isEditable(item.state)" path="/master/Category" tooltip="任意で区分を設定できます。選択項目は【区分一覧】から追加・修正が可能です。"/>
              <AutoComplete title="voucher_list2" :value.sync="item.reserveList2" :editor="editor" list="category_32" :enabled="isEditable(item.state)" path="/master/Category" tooltip="任意で区分を設定できます。選択項目は【区分一覧】から追加・修正が可能です。"/>
              <AutoComplete title="voucher_list3" :value.sync="item.reserveList3" :editor="editor" list="category_33" :enabled="isEditable(item.state)" path="/master/Category" tooltip="任意で区分を設定できます。選択項目は【区分一覧】から追加・修正が可能です。"/>

            </template>
            <!-- 予備項目タブ 右側 -->
            <template slot="right">
              <Calendar title="voucher_date1" :value.sync="item.reserveDate1" :editor="editor" :enabled="isEditable(item.state)" :deletable="true" />
              <Calendar title="voucher_date2" :value.sync="item.reserveDate2" :editor="editor" :enabled="isEditable(item.state)" :deletable="true" />
              <Calendar title="voucher_date3" :value.sync="item.reserveDate3" :editor="editor" :enabled="isEditable(item.state)" :deletable="true" />
              <TextBox title="voucher_memo1" :value.sync="item.reserveMemo1" :editor="editor" :enabled="isEditable(item.state)" length="200" rows="2" />
              <TextBox title="voucher_memo2" :value.sync="item.reserveMemo2" :editor="editor" :enabled="isEditable(item.state)" length="200" rows="2" />
              <TextBox title="voucher_memo3" :value.sync="item.reserveMemo3" :editor="editor" :enabled="isEditable(item.state)" length="200" rows="2" />
            </template>
          </EditPanel>
        </template>

  
        <!-- 入金情報タブ -->
        <template slot="tab5" slot-scope="{item, editor }">
          <EditPanel class="cx_payment_tab">
            <!-- 入金情報タブ 左側 -->
              <template slot="left">
                <NumericBox title="前受金請求額" :value.sync="item.advanceAmountFC" :editor="editor" :enabled="isEditable(item.state)" min="0" :max="item.dealAmountFC < 0 ? 0 : item.dealAmountFC" :decimals="calcUtil.GetCurrecyDecimal(item.currencyCode,$api)" />
                <Calendar title="入金予定日" :value.sync="item.dueDate" :editor="editor" :required="item.advanceAmountFC != 0" :enabled="isEditable(item.state)" :deletable="true" />
           
            </template>
            <!-- 入金情報タブ 右側 -->
            <template slot="right">
              <div class="cx_totals">
                <NumericBox title="入金金額合計(完了)" :value.sync="totalPaymentAmountFC" :editor="editor" :enabled="false" :decimals="calcUtil.GetCurrecyDecimal(item.currencyCode,$api)" />
                <NumericBox title="入金金額合計(確定待ち)" :value.sync="totalPendingAmountFC" :editor="editor" :enabled="false" :decimals="calcUtil.GetCurrecyDecimal(item.currencyCode,$api)" />
              </div>
              <Grid ref="paymentJournalListBox" storageKey="paymentJournalList" :items="paymentJournals" :captions="paymentTabCaptions" :widths="paymentTabWidths">
                <GridItem :slot="paymentTabSlots[0]" slot-scope="{item}"><Badge :value="item.state" list="receivePaymentStatus"/></GridItem>
                <GridItem :slot="paymentTabSlots[1]" slot-scope="{item}">
                  <a class="cx_link_item" @click="onPaymentNoClick(item.debitVoucherNo)">{{ item.debitVoucherNo }}</a>
                </GridItem>
                <GridItem :slot="paymentTabSlots[2]" slot-scope="{item}">{{ item.bookDate | date }}</GridItem>
                <GridItem :slot="paymentTabSlots[3]" slot-scope="{item}">{{ item.currencyCode | currency }}</GridItem>
                <GridItem :slot="paymentTabSlots[4]" slot-scope="{item}">{{ item.bookRate | numeric }}</GridItem>
                <GridItem :slot="paymentTabSlots[5]" slot-scope="{item}">{{ item.amountFC | amountFC(item.currencyCode) }}</GridItem>
                <GridItem :slot="paymentTabSlots[6]" slot-scope="{item}">{{ item.debitAmount | amount }}</GridItem>
              </Grid> 
            </template>
          </EditPanel>
        </template>
        <!-- ワークフロータブ -->
        <template slot="tab6" slot-scope="{ item, editor }">
          <MessageList class="cx_matter_message" :item="item" :editor="editor" />
        </template>
        <!-- 更新履歴タブ -->
        <template slot="tab7" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo" />
        </template>
        <!-- 添付ファイルタブ -->
        <template slot="tab8" slot-scope="{ item, editor }">
          <ListFiles :editor="editor" title="添付ファイル" :height="300" :parentKey="item.auditName" :parentId="item.auditNo" :electronicBookMode="tenantSettings.electronicBookMode" />
        </template>
      </Editor>
      <!-- 入金処理ダイアログ -->
      <ListDialog ref="advanceReceiptDialog" title="入金処理" modelName="Order" :captions="['受注番号', '入金可能額', '入金額']" :widths="[150, 150, 150,]" :showAdd="false" :showRemove="false" :exec="submitAdvanceReceipt" >
        <!-- 入金処理ダイアログ ヘッダ項目 -->
        <template slot="header" slot-scope="{ editor }">
          <!-- <AtcSegment title="部門" :value.sync="rdSegment" :editor="editor" :required="true" /> -->
          <ComboBox title="ワークフロー" :value.sync="rdWorkflowId" :editor="editor" list="workflow_receivePayment" :required="true" :enabled="$api.perms.hasWorkflow('receivePayment')" :nullValue="0" />          
          <AutoComplete title="担当者" :value.sync="rdPic" :editor="editor" list="user" :required="true" />
          <AtcCounterpart title="得意先" :value.sync="rdCounterpart" :editor="editor" :needsCustomer="true" :enabled="false" />
          <AutoComplete title="取引通貨" :value.sync="rdCurrencyCode" :editor="editor" list="currency" :enabled="false" v-if="hasLicenseCurrency"/>
          <Calendar title="入金日" :value.sync="rdReceiptDate" :editor="editor" :required="true" @changed="onChangeRdCurrency" />
          <AtcBankAccount title="入金口座" :value.sync="rdBankAccount" :editor="editor" :required="true" />
          <NumericBox title="入金レート" :value.sync="rdExchageRate" :editor="editor" v-if="hasLicenseCurrency" :required="true" decimals="6" />
        </template>
        <template slot="footer" slot-scope="{ editor }">
          <NumericBox title="決済金額" :value="rdSettlementAmountFC" :enabled="false" :decimals="rdDecimal"/>         
          <NumericBox title="手数料額" :value.sync="rdCommissionAmountFC" :editor="editor" min="0" max="99999999999" :nullValue="0" :decimals="rdDecimal"/>           
          <NumericBox title="口座入金額" :value="rdReceiptAmountFC" :enabled="false" :decimals="rdDecimal"/>
          <!-- <template v-if="hasLicenseCurrency">
            <ComboBox title="手数料額課税区分" :value.sync="rdCommissionTaxFlag" :editor="editor" list="commissionTaxFlag" :required="true" :showDefault="false" />
          </template> -->
          </template>        
        <!-- 入金処理ダイアログ 一覧項目 -->
        <TextBox slot="col0" slot-scope="{ item, editor }" :value="item.orderNo" :editor="editor" :enabled="false" />
        <NumericBox slot="col1" slot-scope="{ item, editor }" :value.sync="item.advancePendingBalanceAmountFC" :editor="editor" :enabled="false" :nullValue="0" :decimals="rdDecimal" />
        <NumericBox slot="col2" slot-scope="{ item, editor }" :value.sync="item.writeoffAmountFC" :editor="editor" :required="true" min="0" :max="item.advancePendingBalanceAmountFC" :decimals="rdDecimal" />
      </ListDialog>
      <!-- 明細一括入力ダイアログ -->
      <ListDialog ref="bundleAddOrderItemDialog" title="明細一括入力" modelName="SalesOrderItem"
        :captions="dlgConfig.gridCaptions"
        :widths="dlgConfig.gridWidths"
        :showAdd="true" :showRemove="true" :exec="submitBundleAddOrderItem"  :onCreate="onItemCreate"  :height="235" :width="1000">
        <!-- 明細一括入力ダイアログ 一覧項目 -->
        <AtcCommodity :slot="dlgConfig.gridSlots[0]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.commodity" :required="true" @update:value="onChangeCommodity(item)"/>
        <TextBox :slot="dlgConfig.gridSlots[1]" slot-scope="{ item, editor }" :value.sync="item.commodityName" :editor="editor" :required="true" length="100" />
        <AtcSKU :slot="dlgConfig.gridSlots[2]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.sku" :commodity="item.commodity" @update:value="getPriceAndTaxCode(item)" />        
        <AtcConversion :slot="dlgConfig.gridSlots[3]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.uom2" :commodity="item.commodity" :required="true" @update:value="getPriceAndTaxCode(item)" />
        <NumericBox :slot="dlgConfig.gridSlots[4]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.quantity" :required="true" :min="(item.commodity && item.commodity.isNoStock) ? -99999999.999 :0" max="99999999.999" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" @update:value="getPriceAndTaxCode(item)" />
        <NumericBox :slot="dlgConfig.gridSlots[5]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.monthlyQuantity" :required="true" :min="(item.commodity && item.commodity.isNoStock) ? -99999999.999 :0" max="99999999.999" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" @update:value="getPriceAndTaxCode(item)" />        
        <NumericBox :slot="dlgConfig.gridSlots[6]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.unitPrice" :required="!tenantSettings.noCheckPriceRequired" min="-999999999.999999" max="999999999.999999" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" />
        <AtcTaxCode :slot="dlgConfig.gridSlots[7]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.taxCode" :taxType="listView.selected.counterpart.taxType" list="taxCode" :required="true" />
        <AtcCounterpart :slot="dlgConfig.gridSlots[8]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.supplier" :needsSupplier="true" />
        <Calendar :slot="dlgConfig.gridSlots[9]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.answerDeliveryDate" :deletable="true" />
        <Calendar :slot="dlgConfig.gridSlots[10]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.scheduledDeliveryDate" :deletable="true" />

        <TextBox :slot="dlgConfig.gridSlots[11]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText1  != usedTypes.CommodityMemo" :value.sync="item.reserveText1" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText1)" />
        <TextBox :slot="dlgConfig.gridSlots[11]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText1 == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText1:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText1)" />
        <TextBox :slot="dlgConfig.gridSlots[12]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText2  != usedTypes.CommodityMemo" :value.sync="item.reserveText2" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText2)" />
        <TextBox :slot="dlgConfig.gridSlots[12]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText2 == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText2:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText2)" />
        <TextBox :slot="dlgConfig.gridSlots[13]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText3  != usedTypes.CommodityMemo" :value.sync="item.reserveText3" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText3)" />
        <TextBox :slot="dlgConfig.gridSlots[13]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText3 == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText3:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText3)" />
        <TextBox :slot="dlgConfig.gridSlots[14]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText4  != usedTypes.CommodityMemo" :value.sync="item.reserveText4" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText4)" />
        <TextBox :slot="dlgConfig.gridSlots[14]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText4 == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText4:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText4)" />
        <TextBox :slot="dlgConfig.gridSlots[15]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText5  != usedTypes.CommodityMemo" :value.sync="item.reserveText5" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText5)" />
        <TextBox :slot="dlgConfig.gridSlots[15]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText5 == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText5:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText5)" />
        <TextBox :slot="dlgConfig.gridSlots[16]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText6  != usedTypes.CommodityMemo" :value.sync="item.reserveText6" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText6)" />
        <TextBox :slot="dlgConfig.gridSlots[16]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText6 == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText6:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText6)" />
        <TextBox :slot="dlgConfig.gridSlots[17]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo1  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo1" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo1)" />
        <TextBox :slot="dlgConfig.gridSlots[17]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo1 == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo1:''" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo1)" />
        <TextBox :slot="dlgConfig.gridSlots[18]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo2  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo2" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo2)" />
        <TextBox :slot="dlgConfig.gridSlots[18]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo2 == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo2:''" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo2)" />
        <TextBox :slot="dlgConfig.gridSlots[19]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo3  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo3" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo3)" />
        <TextBox :slot="dlgConfig.gridSlots[19]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo3 == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo3:''" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo3)" />
        <Calendar :slot="dlgConfig.gridSlots[20]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate1  != usedTypes.CommodityMemo" :value.sync="item.reserveDate1" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate1)" />
        <Calendar :slot="dlgConfig.gridSlots[20]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate1 == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate1: null" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate1)" />
        <Calendar :slot="dlgConfig.gridSlots[21]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate2  != usedTypes.CommodityMemo" :value.sync="item.reserveDate2" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate2)" />
        <Calendar :slot="dlgConfig.gridSlots[21]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate2 == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate2: null" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate2)" />
        <Calendar :slot="dlgConfig.gridSlots[22]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate3  != usedTypes.CommodityMemo" :value.sync="item.reserveDate3" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate3)" />
        <Calendar :slot="dlgConfig.gridSlots[22]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate3 == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate3: null" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate3)" />
        <AutoComplete :slot="dlgConfig.gridSlots[23]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList1  != usedTypes.CommodityMemo" :value.sync="item.reserveList1" :editor="editor" list="category_41" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList1)" path="/master/Category" />
        <AutoComplete :slot="dlgConfig.gridSlots[23]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList1 == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList1:''" :editor="editor" list="category_41" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList1)" path="/master/Category" />
        <AutoComplete :slot="dlgConfig.gridSlots[24]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList2  != usedTypes.CommodityMemo" :value.sync="item.reserveList2" :editor="editor" list="category_42" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList2)" path="/master/Category" />
        <AutoComplete :slot="dlgConfig.gridSlots[24]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList2:''" :editor="editor" list="category_42" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList2)" path="/master/Category" />
        <AutoComplete :slot="dlgConfig.gridSlots[25]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList3 != usedTypes.CommodityMemo" :value.sync="item.reserveList3" :editor="editor" list="category_43" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList3)" path="/master/Category" />
        <AutoComplete :slot="dlgConfig.gridSlots[25]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList3 == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList3:''" :editor="editor" list="category_43" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList3)" path="/master/Category" />

        <template slot="header" slot-scope="{ editor }" v-if ="isSubscription">
            <EditPanel>
              <template slot="left">
                <Calendar title="契約開始日" :value.sync="subscriptionStartDate" :editor="editor" />
                <Calendar title="契約完了日" :value.sync="subscriptionEndDate" :editor="editor" />      
              </template>
            </EditPanel>    
        </template>

      </ListDialog>
      <!-- SKU一括入力ダイアログ -->
      <ListDialog ref="skuBundleAddOrderItemDialog" title="SKU一括入力" modelName="SalesOrderItem"
        :captions="dlgSkuConfig.gridCaptions"
        :widths="dlgSkuConfig.gridWidths"
        :showAdd="false" :showRemove="false" :exec="submitSkuBundleAddOrderItemQuery"
        :height=220
      >
        <!-- SKU一括入力ダイアログ ヘッダ項目 -->
        <template slot="header" slot-scope="{ editor }">
          <AtcCommodity title="商品" :value.sync="sbaoiHeaderItem.commodity" :editor="editor" :required="true" @update:value="onChangeCommodity2()" tooltip="登録する商品を選択します。【商品一覧】のデータを選択できます。"/>
          <TextBox title="商品名称" :value.sync="sbaoiHeaderItem.commodityName" :editor="editor" :required="true" length="100" tooltip="初期値は【商品】で選択した商品の【商品名称】が表示されますが､任意で変更が可能です。"/>
          <!-- <ComboBox title="単位" :value.sync="sbaoiHeaderItem.package" :editor="editor" :provider="() => sbaoiHeaderItem.getConversion()" :required="true" @update:value="onChangePackage()" /> -->
          <AtcConversion title="単位" :value.sync="sbaoiHeaderItem.uom2" :editor="editor"  :commodity="sbaoiHeaderItem.commodity" :required="true" @update:value="onChangePackage()" />            
          <AtcTaxCode title="税区分" :value.sync="sbaoiHeaderItem.taxCode" :taxType="listView.selected.counterpart.taxType" :editor="editor" list="taxCode" :required="true" tooltip="登録する税区分を選択します。【税区分一覧】のデータを選択できます。"/>
          <AtcCounterpart title="発注先" :value.sync="sbaoiHeaderItem.supplier" :editor="editor" :needsSupplier="true" tooltip="商品を発注する仕入先を選択します。【取引先一覧】の【取引先種別】が【仕入先】になっているデータが選択できます。"/>
          <Calendar title="出荷予定日" :value.sync="scheduledDeliveryDateSKU" tooltip="受注した商品の出荷を予定している日付を入力します。"/>
        </template>
        <!-- SKU一括入力 一覧項目 -->
        <AtcSKU :slot="dlgSkuConfig.gridSlots[0]" slot-scope="{ item, editor }" :value.sync="item.sku" :editor="editor" :commodity="item.commodity" :enabled="false" />
        <NumericBox :slot="dlgSkuConfig.gridSlots[1]" slot-scope="{ item, editor }" :value.sync="item.quantity" :editor="editor"  :min="(item.commodity && item.commodity.isNoStock) ? -99999999.999 :0" max="99999999.999" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" @update:value="getPriceAndTaxCode(item)" />
        <NumericBox :slot="dlgSkuConfig.gridSlots[2]" slot-scope="{ item, editor }" :value.sync="item.unitPrice" :editor="editor" :required="!tenantSettings.noCheckPriceRequired && item.quantity != 0" min="-999999999.999999" max="999999999.999999" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" />

        <TextBox :slot="dlgSkuConfig.gridSlots[3]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText1  != usedTypes.CommodityMemo" :value.sync="item.reserveText1" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText1)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[3]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText1:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText1)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[4]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText2  != usedTypes.CommodityMemo" :value.sync="item.reserveText2" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText2)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[4]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText2:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText2)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[5]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText3  != usedTypes.CommodityMemo" :value.sync="item.reserveText3" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText3)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[5]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText3:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText3)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[6]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText4  != usedTypes.CommodityMemo" :value.sync="item.reserveText4" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText4)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[6]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText4  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText4:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText4)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[7]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText5  != usedTypes.CommodityMemo" :value.sync="item.reserveText5" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText5)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[7]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText5  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText5:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText5)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[8]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText6  != usedTypes.CommodityMemo" :value.sync="item.reserveText6" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText6)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[8]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText6  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText6:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText6)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[9]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo1  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo1" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo1)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[9]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo1:''" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo1)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[10]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo2  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo2" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo2)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[10]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo2:''" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo2)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[11]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo3  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo3" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo3)" />
        <TextBox :slot="dlgSkuConfig.gridSlots[11]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo3:''" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo3)" />
        <Calendar :slot="dlgSkuConfig.gridSlots[12]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate1  != usedTypes.CommodityMemo" :value.sync="item.reserveDate1" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate1)" />
        <Calendar :slot="dlgSkuConfig.gridSlots[12]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate1: null" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate1)" />
        <Calendar :slot="dlgSkuConfig.gridSlots[13]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate2  != usedTypes.CommodityMemo" :value.sync="item.reserveDate2" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate2)" />
        <Calendar :slot="dlgSkuConfig.gridSlots[13]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate2: null" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate2)" />
        <Calendar :slot="dlgSkuConfig.gridSlots[14]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate3  != usedTypes.CommodityMemo" :value.sync="item.reserveDate3" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate3)" />
        <Calendar :slot="dlgSkuConfig.gridSlots[14]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate3: null" :editor="editor" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate3)" />
        <AutoComplete :slot="dlgSkuConfig.gridSlots[15]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList1  != usedTypes.CommodityMemo" :value.sync="item.reserveList1" :editor="editor" list="category_41" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList1)" path="/master/Category" />
        <AutoComplete :slot="dlgSkuConfig.gridSlots[15]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList1:''" :editor="editor" list="category_41" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList1)" path="/master/Category" />
        <AutoComplete :slot="dlgSkuConfig.gridSlots[16]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList2  != usedTypes.CommodityMemo" :value.sync="item.reserveList2" :editor="editor" list="category_42" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList2)" path="/master/Category" />
        <AutoComplete :slot="dlgSkuConfig.gridSlots[16]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList2:''" :editor="editor" list="category_42" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList2)" path="/master/Category" />
        <AutoComplete :slot="dlgSkuConfig.gridSlots[17]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList3  != usedTypes.CommodityMemo" :value.sync="item.reserveList3" :editor="editor" list="category_43" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList3)" path="/master/Category" />
        <AutoComplete :slot="dlgSkuConfig.gridSlots[17]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList3:''" :editor="editor" list="category_43" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList3)" path="/master/Category" />
      </ListDialog>


      <!-- 定期出荷ダイアログ -->
      <ListDialog ref="regularlyDeliveryDialog" title="定期出荷" modelName="SalesOrderItem" :buttonNames="buttonNames"
        :captions="dlgRegularlyDeliveryConfig.gridCaptions"
        :widths="dlgRegularlyDeliveryConfig.gridWidths"
        :showAdd="false" :showRemove="false" :execWithIndex="submitRegularlyDeliveryQuery"
        :height=220
      >
        <!-- 定期出荷入力ダイアログ ヘッダ項目 -->
        <template slot="header" slot-scope="{ editor }">
          <EditPanel>
            <template slot="left">
              <ComboBox title="ワークフロー" :value.sync="regdWorkflowId" :editor="editor" :required="regdWorkflowRequired" :enabled="regdWorkflowRequired" list="workflow_salesDelivery" :nullValue="0" @changed="onChangeregdWorkflow()" tooltip="出荷時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【出荷管理】になっているデータから選択ができます。" />
              <AutoComplete title="担当者" :value.sync="regdPic" :editor="editor" :required="true" list="user" tooltip="案件を担当する人を選択します。【ユーザー】のデータを選択することができます。"/>
              <TextBox title="出荷管理番号" :value.sync="regdRefNo" :editor="editor" length="30" tooltip="登録する出荷に対して出荷管理番号を入力することができます。一律同一の番号が設定されます。"/>
              <Calendar title="出荷開始月" :value.sync="regdRegularlyStartMonth" :editor="editor" :required="true" :month="true" tooltip="定期出荷の開始基準月です。指定された月から出荷サイクルごとに出荷が作成されます。" />
              <!-- <ComboBox title="出荷開始月" :value.sync="regdRegularlyStartMonth" :editor="editor" :required="true" list="monthList" :nullValue="0" tooltip="定期出荷の開始基準月です。指定された月から出荷サイクルごとに出荷が作成されます。" /> -->
              <ComboBox title="定期出荷日" :value.sync="regdRegularlyDate" :editor="editor" :required="true" list="dateTypes" :showDefault="false" :nullValue="0" tooltip="定期出荷の出荷日です。出荷伝票の日付に設定されます。" />
              <ComboBox title="定期出荷サイクル" :value.sync="regdRegularlySycle" :editor="editor" :required="true" list="regularlySycle" :nullValue="0" tooltip="出荷開始月から、どのようなサイクルで出荷伝票を作成するかを設定します。" />
              <NumericBox title="回数" :value.sync="regdRegularlyTimes" :editor="editor" :required="true" tooltip="出荷伝票の作成回数です。指定された回数分の出荷伝票が作成されます。" />
            </template>
          </EditPanel>
        </template>
        <!-- 定期出荷入力 一覧項目 -->
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[0]" slot-scope="{ item, editor }" :value="item.commodity.name" :editor="editor" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[1]" slot-scope="{ item, editor }" :value="item.sku ? item.sku.name : ''" :editor="editor" :enabled="false" />
        <AtcConversion :slot="dlgRegularlyDeliveryConfig.gridSlots[2]" slot-scope="{ item, editor }" :value.sync="item.uom2" :editor="editor" :enabled="false" />
        <NumericBox :slot="dlgRegularlyDeliveryConfig.gridSlots[3]" slot-scope="{ item, editor }" :value.sync="item.regularlyQuantity" :editor="editor" :min="0" :max="regdRegularlyTimes==0?item.backOrderQuantity:calcUtil.Round(item.backOrderQuantity / regdRegularlyTimes, item.commodity.quantityScale, roundDown)" :nullValue="0" :decimals="item.commodity.quantityScale" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[4]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText1  != usedTypes.CommodityMemo" :value.sync="item.reserveText1" :editor="editor" length="50" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[4]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText1:''" :editor="editor" length="50" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[5]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText2  != usedTypes.CommodityMemo" :value.sync="item.reserveText2" :editor="editor" length="50" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[5]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText2:''" :editor="editor" length="50" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[6]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText3  != usedTypes.CommodityMemo" :value.sync="item.reserveText3" :editor="editor" length="50" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[6]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText3:''" :editor="editor" length="50" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[7]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText4  != usedTypes.CommodityMemo" :value.sync="item.reserveText4" :editor="editor" length="50" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[7]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText4  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText4:''" :editor="editor" length="50" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[8]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText5  != usedTypes.CommodityMemo" :value.sync="item.reserveText5" :editor="editor" length="50" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[8]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText5  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText5:''" :editor="editor" length="50" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[9]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText6  != usedTypes.CommodityMemo" :value.sync="item.reserveText6" :editor="editor" length="50" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[9]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText6  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText6:''" :editor="editor" length="50" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[10]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo1  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo1" :editor="editor" length="200" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[10]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo1:''" :editor="editor" length="200" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[11]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo2  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo2" :editor="editor" length="200" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[11]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo2:''" :editor="editor" length="200" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[12]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo3  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo3" :editor="editor" length="200" :enabled="false" />
        <TextBox :slot="dlgRegularlyDeliveryConfig.gridSlots[12]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo3:''" :editor="editor" length="200" :enabled="false" />
        <Calendar :slot="dlgRegularlyDeliveryConfig.gridSlots[13]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate1  != usedTypes.CommodityMemo" :value.sync="item.reserveDate1" :editor="editor" :enabled="false" />
        <Calendar :slot="dlgRegularlyDeliveryConfig.gridSlots[13]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate1: null" :editor="editor" :enabled="false" />
        <Calendar :slot="dlgRegularlyDeliveryConfig.gridSlots[14]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate2  != usedTypes.CommodityMemo" :value.sync="item.reserveDate2" :editor="editor" :enabled="false" />
        <Calendar :slot="dlgRegularlyDeliveryConfig.gridSlots[14]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate2: null" :editor="editor" :enabled="false" />
        <Calendar :slot="dlgRegularlyDeliveryConfig.gridSlots[15]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate3  != usedTypes.CommodityMemo" :value.sync="item.reserveDate3" :editor="editor" :enabled="false" />
        <Calendar :slot="dlgRegularlyDeliveryConfig.gridSlots[15]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate3: null" :editor="editor" :enabled="false" />
        <AutoComplete :slot="dlgRegularlyDeliveryConfig.gridSlots[16]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList1  != usedTypes.CommodityMemo" :value.sync="item.reserveList1" :editor="editor" list="category_41" :enabled="false" path="/master/Category" />
        <AutoComplete :slot="dlgRegularlyDeliveryConfig.gridSlots[16]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList1:''" :editor="editor" list="category_41" :enabled="false" path="/master/Category" />
        <AutoComplete :slot="dlgRegularlyDeliveryConfig.gridSlots[17]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList2  != usedTypes.CommodityMemo" :value.sync="item.reserveList2" :editor="editor" list="category_42" :enabled="false" path="/master/Category" />
        <AutoComplete :slot="dlgRegularlyDeliveryConfig.gridSlots[17]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList2:''" :editor="editor" list="category_42" :enabled="false" path="/master/Category" />
        <AutoComplete :slot="dlgRegularlyDeliveryConfig.gridSlots[18]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList3  != usedTypes.CommodityMemo" :value.sync="item.reserveList3" :editor="editor" list="category_43" :enabled="false" path="/master/Category" />
        <AutoComplete :slot="dlgRegularlyDeliveryConfig.gridSlots[18]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList3:''" :editor="editor" list="category_43" :enabled="false" path="/master/Category" />
      </ListDialog>
      <!-- 納期更新画面 -->
    　<b-modal v-model="showSubscriptionDateUpdate" title="契約日付更新" @ok="onSubscriptionDateUpdate" :no-close-on-backdrop="true" centered v-if="showSubscriptionDateUpdate">
          <Calendar title="契約開始日" :value.sync="subscriptionStartDate" :deletable="true" tooltip="契約開始日を更新します。更新しない場合はブランクを指定します。"/>
          <Calendar title="契約完了日" :value.sync="subscriptionEndDate" :deletable="true" tooltip="契約完了日を更新します。更新しない場合はブランクを指定します。"/>
      </b-modal>

    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class SalesOrderView extends Vue {
  public createPurchaseOrder = Components.CreatePurchaseOrder;
  public updateDeliveryDate = Components.UpdateDeliveryDate;
  public shippingInstructionDialog = Components.ShippingInstruction;
  public items: Common.SalesOrder[] = new Array(0);
  public params: Common.OrderQuery = new Common.OrderQuery(Common.SalesPurchaseFlags.Sales);
  public importQuery = new Common.OrderImportQuery('受注',Common.SalesPurchaseFlags.Sales);
  public exportQuery = new Common.OrderExportQuery('受注', this.params,Common.SalesPurchaseFlags.Sales);
  public calcUtil: Common.CalcUtil = new Common.CalcUtil();
  public usedTypes = Common.UsedTypes;  
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'orderNo', text: '受注番号' },
    { value: 'orderDate', text: '受注日' },
    { value: 'counterpart', text: '得意先' },
    { value: 'requestDate', text: '希望納期' },
    { value: 'receiver', text: '納入先' },
    { value: 'projectItem', text: '案件' },      
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'refNo', text: '受注管理番号' },
    { value: 'customerOrderNo', text: '顧客注文番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true, true, true, true];
  public tabVisiblesOnInsert: Array<boolean> = [true, true, true, true, true, false, false, false, false];  
  public tenantSettings: Common.TenantSettings = null;
  public hasLicenseCurrency: boolean = false;
  public hasLicenseExport: boolean = false;
  @Prop() public orderNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor;  

  public voucherTypes = Common.voucherTypes;
  //伝票インポート用
  public salesOrderImportQuery = new Common.VoucherImportQuery("SalesOrderImportQuery", Common.SalesOrder);

  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');
  public dlgConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');//明細一括入力
  public dlgSkuConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');//SKU一括入力
  public dlgRegularlyDeliveryConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');//定期出荷入力

  // 入金情報タブ可変表示用プロパティ
  public paymentTabCaptions = new Array();
  public paymentTabWidths = new Array();
  public paymentTabSlots = new Array();
  public paymentTabGridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('状態', 120),
      new Common.GridItemConfiguration('入金伝票番号', 150),
      new Common.GridItemConfiguration('入金日', 120),
    ],
    3, // 入金日の次を可変表示項目の挿入位置に指定
    'col'
  );
  // ライセンスによって表示の切り替わる項目
  public paymentTabVariableGridItems1: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('入金通貨', 150),
    new Common.GridItemConfiguration('入金レート', 150)
  ];
  public paymentTabVariableGridItems2: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('入金金額', 150)
  ];
  public paymentTabVariableGridItems3: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('入金計上額', 150)
  ];

  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    this.hasLicenseExport = this.$api.hasLicense(Common.licenseFlags.export);
    // 一覧表示項目の制御
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      new Common.GridItemConfiguration('受注番号', 150),
      new Common.GridItemConfiguration('ワークフロー', 250),
      new Common.GridItemConfiguration('受注日', 120),
      new Common.GridItemConfiguration('得意先', 200),
      new Common.GridItemConfiguration('希望納期', 120),
      new Common.GridItemConfiguration('納入先', 200),
      new Common.GridItemConfiguration('納入先名称', 200),
      new Common.GridItemConfiguration('取引通貨', 150,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('受注管理番号', 120),
      new Common.GridItemConfiguration('顧客注文番号', 150),
      new Common.GridItemConfiguration('案件', 150),            
      new Common.GridItemConfiguration('部門', 120),
      new Common.GridItemConfiguration('担当者', 120),
      new Common.GridItemConfiguration('受注金額', 120),
      new Common.GridItemConfiguration('税計算区分', 120),
      new Common.GridItemConfiguration('前受金請求額', 150,this.hasLicenseExport),
      new Common.GridItemConfiguration('前受金請求残高', 150,this.hasLicenseExport),
      new Common.GridItemConfiguration('前受金残高', 120,this.hasLicenseExport),
      new Common.GridItemConfiguration('前受金消込額(確定待ち)',180,this.hasLicenseExport),
      new Common.GridItemConfiguration('入金予定日', 120,this.hasLicenseExport),
      new Common.GridItemConfiguration('インポート番号', 100),       
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 120),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 120)
    );
    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    // インポート・エクスポートの制御
    this.importQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.importQuery.hasLicenseExport = this.hasLicenseExport;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.exportQuery.hasLicenseExport = this.hasLicenseExport;
    // タブ表示の制御
    this.$set(this.tabVisibles, 4, this.$api.useStockFunction); // 予備項目タブ
    this.$set(this.tabVisiblesOnInsert, 4, this.$api.useStockFunction); // 予備項目タブ
    this.$set(this.tabVisibles, 5, this.hasLicenseExport); // 入金情報タブ
    this.paymentTabVariableGridItems1.forEach(item => item.IsVisible = this.hasLicenseCurrency);
    this.paymentTabVariableGridItems3.forEach(item => item.IsVisible = this.hasLicenseCurrency);
    // 入金情報タブの表示項目制御
    this.paymentTabVariableGridItems1 = this.paymentTabVariableGridItems1.concat(this.paymentTabVariableGridItems2);
    this.paymentTabVariableGridItems1 = this.paymentTabVariableGridItems1.concat(this.paymentTabVariableGridItems3);
    this.paymentTabGridConfig.setVariableItems(this.paymentTabVariableGridItems1);
    this.paymentTabCaptions = this.paymentTabGridConfig.gridCaptions;
    this.paymentTabWidths = this.paymentTabGridConfig.gridWidths;
    this.paymentTabSlots = this.paymentTabGridConfig.gridSlots;
    //明細一括入力用のグリッド
    // this.dlgConfig.setGridItemsFromCaptions(
    //   ['商品','商品名称','SKU',  '単位', '受注数量', '単価', '税区分', '発注先', '回答納期', '出荷予定日'],
    //   [250, 150, 200, 120, 130, 130, 120, 200, 130, 130]
    // );
    // this.dlgConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,false,true,false));//商品識別情報+商品メモ+受発注メモ

    //SKU一括入力用のグリッド
    this.dlgSkuConfig.setGridItemsFromCaptions(
      ['SKU', '受注数量', '単価'],
      [150, 150, 150]
    );
    this.dlgSkuConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,false,true,false));//商品識別情報+商品メモ+受発注メモ

    //定期出荷入力用のグリッド
    this.dlgRegularlyDeliveryConfig.setGridItemsFromCaptions(
      ['商品', 'SKU', '単位', '定期数量',],
      [250, 150, 150, 150]
    );
    this.dlgRegularlyDeliveryConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,true,true,false));//商品識別情報+商品メモ+受発注メモ

    // 検索条件を設定する
    if(this.orderNo) {
      this.params.orderNo = this.orderNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
    }
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
    // 子画面用ワークフロー情報をロードする
    this.$api.formatter.ensureListLoaded('workflow_purchaseOrder');
    this.$api.formatter.ensureListLoaded('workflow_salesDelivery');
    this.$api.formatter.ensureListLoaded('workflow_receivePayment');
    var workflows = this.$api.formatter.getOptions('workflow_salesDelivery');
    this.regdWorkflowRequired = workflows.length > 0;
  }

  public async onCreate(obj: Common.SalesOrder) {
    const workflows = this.$api.formatter.getOptions('workflow_salesOrder');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    obj.pic = this.$api.auth.userId;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
      //受注明細タブのリロード
       (this.$refs.salesOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();           
  }

  // 状態から編集可能か判別する
  public isEditable(state: Common.OrderStatus):boolean{
    if(state == Common.OrderStatus.SalesOrderSaving) return true;
    if(state == Common.OrderStatus.SalesOrderWaiting) return true;
    return false;
  }
  // 完了以外で編集可能
  public isEditableNoComplete(state: Common.OrderStatus):boolean{
    if(state == Common.OrderStatus.SalesOrderCompleted) return false;
    return true;
  }

  public selectedSalesOrderItems(){
    //明細処理でorderのロード状態が十分ではない場合があるため、送信する前にorderをセットする
    var items =  (this.$refs.salesOrderItems as Components.GrdVoucherItem).selectedItems as Common.OrderItem[];
    items.forEach(obj =>obj.order = (this.$refs.mainList as Components.ListView).selected as Common.Order);
    return items;
  }
  public allSalesOrderItems(){
    //明細処理でorderのロード状態が十分ではない場合があるため、送信する前にorderをセットする
    var items =  (this.$refs.salesOrderItems as Components.GrdVoucherItem).items as Common.OrderItem[];
    items.forEach(obj =>obj.order = (this.$refs.mainList as Components.ListView).selected as Common.Order);
    return items;
  }  
  // 得意先変更時に得意先の通貨を設定する
  public onChangeCustomer(item: Common.Order, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.currencyCode = item.counterpart ? item.counterpart.currencyCode : '';
    if (item.counterpart && item.counterpart.salesPerson) item.pic = item.counterpart.salesPerson;
    item.onChangeCounterpart()
  }

  // 納入先変更時に納入先詳細を設定する
  public onChangeReceiver(item: Common.Order, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.onChangeReceiver();
  }

  // 一覧でチェックされている受注伝票
  public checkedOrders: Array<Common.Order>= new Array(0);
  public getCheckedOrders(){
    this.checkedOrders = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        obj.writeoffAmountFC = 0;
        this.checkedOrders.push(obj);
      }
    });
  }

  // 一覧選択時に明細表示ボタンを非活化状態・入金情報タブを更新
  public onSelectedMain(index: number, selected: Common.Order) {
    // 明細表示ボタンの非活化状態を更新
    this.updateDisabledShowItemButton(selected);
    
    // 発注明細表示・出荷明細表示ボタンの非活化状態を更新
    this.disabledShowReferenceItemButton
      = selected.state != Common.OrderStatus.SalesOrderItemsOperating
      && selected.state != Common.OrderStatus.SalesOrderCompleted;

    //入金情報タブを更新
    this.totalPaymentAmountFC = 0;
    this.totalPendingAmountFC = 0;
    this.paymentJournals = new Array(0);
    if(index >= 0) this.refreshPaymentList();
  }

  // 入金処理用プロパティ
  public rdSegment: Common.Segment = null;
  public rdPic: string = '';
  public rdWorkflowId: number = 0;
  public rdCounterpart: Common.Counterpart = null;
  public rdCurrencyCode: string = '';
  public rdReceiptDate: Date = null;
  public rdBankAccount: Common.BankAccount = null;
  public rdExchageRate: number = 0;
  public get rdReceiptAmountFC(): number { return this.rdSettlementAmountFC - this.rdCommissionAmountFC; };
  public rdCommissionAmountFC: number = 0;
  public rdCommissionTaxFlag: boolean = false;
  public get rdSettlementAmountFC(): number {
    if(this.checkedOrders.length == 0) return 0;
    return this.checkedOrders.map(obj => obj.writeoffAmountFC).reduce((total, value) =>(total + value));
  };
  public rdDecimal: number = 0;

  // 入金処理ダイアログの表示
  public showAdvanceReceiptDialog() {
    this.getCheckedOrders();

    // ダイアログ表示前バリデーション
    if(this.checkedOrders.length == 0){
      this.$api.modal.show('', '受注伝票を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrders.filter(order=> this.checkedOrders[0].counterpart.id != order.counterpart.id).length > 0){
      this.$api.modal.show('', '同一得意先の受注伝票を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrders.filter(order=> this.checkedOrders[0].currencyCode != order.currencyCode).length > 0){
      this.$api.modal.show('', '同一取引通貨の受注伝票を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrders.filter(order=> this.checkedOrders[0].segmentId != order.segmentId).length > 0){
      this.$api.modal.show('', '同一部門の受注伝票を選択して下さい。', true, null);
      return;
    }    
    if(this.checkedOrders.filter(order=> (order.state & (Common.OrderStatus.SalesOrderReceiptWaiting | Common.OrderStatus.SalesOrderPartialReceiptWaiting)) <= Common.OrderItemStatus.PurchaseOrder).length > 0){
      this.$api.modal.show('', '前受金入金待ち、または前受金一部入金の受注伝票を選択して下さい。', true, null);
      return;
    }

    // 入力項目の初期化
    this.rdSegment = this.checkedOrders[0].segment; //発生部門をセット(非表示)
    this.rdPic = this.$api.auth.userId;
    this.rdWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_receivePayment');
    this.rdCounterpart = this.checkedOrders[0].counterpart;
    this.rdCurrencyCode = this.checkedOrders[0].currencyCode;
    this.rdReceiptDate = this.checkedOrders.map(order => order.dueDate).reduce((min, value) => min = (min == null || min > value) ? value : min);
    this.rdExchageRate = 1;
    this.rdCommissionAmountFC = 0;
    this.rdCommissionTaxFlag = true; // 販売管理では課税固定
    this.onChangeRdCurrency();
    this.getBankAccount();

    this.rdDecimal = 0;
    const obj = this.$api.currencies.filter(obj => obj.value == this.rdCurrencyCode);
    if (obj.length > 0) this.rdDecimal = Number(obj[0].text);

    // ダイアログの表示
    (this.$refs.advanceReceiptDialog as Components.ListDialog).items = this.checkedOrders;
    (this.$refs.advanceReceiptDialog as Components.ListDialog).showDialog();
  }

  public async onChangeRdCurrency(){
    const query = new Common.GetExchangeRateQuery();
    query.currency = this.rdCurrencyCode;
    query.startDate = this.rdReceiptDate;
    this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      this.rdExchageRate = exchangeRate ? exchangeRate.rate : 1;
    });
  }

  public async getBankAccount(){
    const query = new Common.GetBankAccount();
    query.currencyCode = this.rdCurrencyCode;
    this.$api.execute(query).then(res => {
      this.rdBankAccount = res as Common.BankAccount;
    });
  }

  // 入金処理の実行
  public async submitAdvanceReceipt(list: Array<Common.Order>)
  {
    // クエリの設定
    var query = new Common.AdvanceReceiptQuery();
    query.segment = this.rdSegment;
    query.pic = this.rdPic;
    query.counterpart = this.rdCounterpart;
    query.currencyCode = this.rdCurrencyCode;
    query.receiptDate = this.rdReceiptDate;
    query.bankAccount = this.rdBankAccount;
    query.exchangeRate = this.rdExchageRate;
    query.commissionAmountFC = this.rdCommissionAmountFC;
    query.settlementAmountFC = this.rdSettlementAmountFC;
    query.commissionTaxFlag = this.rdCommissionTaxFlag;
    query.orders = list;
    query.workflowId = this.rdWorkflowId;
    
    // 入金処理後、入金一覧へ画面遷移
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/cash/Deposit?paymentNo={0}',(res as Common.Payment).paymentNo));      
    // });
    return this.$api.execute(query,true).then(res => {
      //リストリロード
      (this.$refs.mainList as Components.ListView).reload();
      var payment = res as Common.Payment;
      //入金明細タブのリロード
      this.refreshPaymentList();
      this.$api.modal.show('処理結果','以下の入金伝票が作成されました。',true,null,[new Common.ModalLink(payment.paymentNo, String.format('/cash/Deposit?paymentNo={0}',payment.paymentNo))]);
      return true;
    }).catch(()=>{return false;});    
  }

  // 明細表示ボタンの非活性判別
  public disabledShowItemButton: boolean = true;
  public  updateDisabledShowItemButton(order:Common.Order){
    this.disabledShowItemButton = true;
    
    var query = new Common.GetOrderItemQuery();
    query.orderNo = order.orderNo;
    this.$api.execute(query).then(res => {
      this.disabledShowItemButton = res.length == 0;
    });
  }

  // 明細一括入力・SKU一括入力ボタンの非活性判別
  public  disabledAddItemButton(order:Common.SalesOrder):boolean{
    // 2020.08.13 非活性条件の変更 バグ422
    // return order.state >= Common.OrderStatus.SalesOrderItemsOperateWaiting;
    // 2023.10.17 受注確定待ちを活性に変更
    return order.state > Common.OrderStatus.SalesOrderWaiting;
  }
  // 出荷指示・発注処理ボタンの非活性判別
  public  disabledOrderItemFuncButton(order:Common.SalesOrder):boolean{
    return order.state < Common.OrderStatus.SalesOrderItemsOperateWaiting || order.state == Common.OrderStatus.SalesOrderCompleted;
  }

  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.SalesOrder){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.SalesOrder, sourceNo : item.orderNo},this.$el);
  }

  // 受注明細一覧を表示
  public showSalesOrderItems() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;
    let routeData = this.$router.resolve(String.format('/sales/SalesOrderItem?orderNo={0}',obj.orderNo));
    window.open(routeData.href, '_blank');
  }

  // 発注明細表示・出荷明細表示ボタンの非活性判別
  public disabledShowReferenceItemButton: boolean = true;


  // 発注明細一覧を表示
  public showPurchaseOrderItems(event :any) {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;
    let routeData = this.$router.resolve(String.format('/purchase/PurchaseOrderItem?salesOrderItemNo={0}',obj.orderNo));
    window.open(routeData.href, '_blank');
  }

  // 出荷明細一覧を表示
  public showSalesDeliveryItems() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;
    let routeData = this.$router.resolve(String.format('/sales/SalesDeliveryItem?orderItemNo={0}',obj.orderNo));
    window.open(routeData.href, '_blank');
  }
  public createDelivery(){
    // var count = this.selectedSalesOrderItems.length;
  }

  public subscriptionStartDate: Date = null;
  public subscriptionEndDate: Date = null;  
  public isSubscription: boolean = false;
  // 明細一括入力ダイアログを表示
  public showBundleAddOrderItemDialog() {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;
    
    // 新規の場合、編集中のものを設定
    if(parent.counterpart == null){
      this.$api.modal.show('', '得意先を指定してください。', true, null);
      return ;
    }
    this.isSubscription = parent.isSubscription;
    //サブスクリプション用の契約開始日・完了日をセットする
    this.subscriptionStartDate = new Date().getBeginDate();
    this.subscriptionEndDate = new Date().getBeginDate();
    this.subscriptionEndDate.setMonth(this.subscriptionEndDate.getMonth() + 1);
    this.subscriptionEndDate.setDate(0);

    //グリッド設定
    this.dlgConfig = new Common.GridConfiguration([],0, 'col');

    this.dlgConfig.setGridItems(
      new Common.GridItemConfiguration('商品', 250),
      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('SKU', 200,this.$api.useStockFunction),
      new Common.GridItemConfiguration('単位', 120),
      new Common.GridItemConfiguration('受注数量', 130,parent.isSubscription == false),
      new Common.GridItemConfiguration('月次数量', 130,parent.isSubscription == true),      
      new Common.GridItemConfiguration('単価', 130),
      new Common.GridItemConfiguration('税区分', 120),
      new Common.GridItemConfiguration('発注先', 200,parent.isSubscription == false),
      new Common.GridItemConfiguration('回答納期', 130,parent.isSubscription == false),
      new Common.GridItemConfiguration('出荷予定日', 130, parent.isSubscription == false)
    );    

    this.dlgConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,false,true,false));//商品識別情報+商品メモ+受発注メモ

    var items = new Array();
    var instance = new Common.SalesOrderItem();
    instance.taxCode = parent.counterpart.taxCode;
    items.push(instance);
    (this.$refs.bundleAddOrderItemDialog as Components.ListDialog).items = items;
    (this.$refs.bundleAddOrderItemDialog as Components.ListDialog).showDialog();
  }

  //明細一括入力ダイアログの予備項目の活性・非活性を切り替える
  public isEditable2(usedType: Common.UsedTypes){
    //商品識別情報,受発注メモは活性。それ以外は非活性
        if(usedType == Common.UsedTypes.CommodityAttribute ||usedType == Common.UsedTypes.OrderMemo)  return true;else return false;
  }

  // 商品変更時に商品名・単価・税区分・予備項目を設定する
  public onChangeCommodity(item:Common.OrderItem){
    item.onChangeCommodity(this.tenantSettings);
    this.getPriceAndTaxCode(item);
  }

  // 単価・税区分を取得する
  public getPriceAndTaxCode(item:Common.SalesOrderItem){
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.Order;
    this.$api.execute(new Common.OrderGetItemPriceQuery(parent, item)).then(res => {
      item.unitPrice = res.unitPrice;
      item.taxCode = res.taxCode;
    });
  }

  //行追加時に税区分の初期値を設定
  public async onItemCreate(obj:Common.SalesOrderItem){
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;
    obj.taxCode = parent.counterpart.taxCode;
    return Promise.resolve(obj);
  }

public submitBundleAddOrderItemRun(){
  const items = (this.$refs.salesOrderItems as Components.GrdVoucherItem).items;
  if(items.length > 0) this.submitBundleAddOrderItem(items);
}
  // 明細一括入力の実行
  public async submitBundleAddOrderItem(list: Array<Common.SalesOrderItem>) {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;
    var items = new Array();
    await list.forEach(async obj => {
      obj.order = parent;
      obj.purchasePrice = obj.commodity.purchasePrice;
      //サブスクリプション開始日・完了日を設定
      if (parent.isSubscription) {
        obj.subscriptionStartDate = this.subscriptionStartDate;
        obj.subscriptionEndDate = this.subscriptionEndDate;
        obj.answerDeliveryDate = null;
        obj.scheduledDeliveryDate = null;
        obj.supplier = null;
      }
      items.push(obj);
    });
    //新規追加時は明細を一時的に保持する
    if((this.$refs.mainList as Components.ListView).isInsertMode){
     (this.$refs.salesOrderItems as Components.GrdVoucherItem).mergeItems(items);
      return true;
    }
    var query = new Common.BundleAddOrderItemQuery(Common.SalesPurchaseFlags.Sales);
    query.orderItems = items;
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/sales/SalesOrderItem?orderNo={0}',parent.orderNo));
    // });    
    return this.$api.execute(query).then(res => {
      //受注金額が更新されるのでリストを更新する
       (this.$refs.mainList as Components.ListView).onSubmit(res).finally(()=>{
        //受注明細タブのリロード
        (this.$refs.salesOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();      
        //事後アクションダイアログを表示するためコメントアウト
        //this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      }); 
      return true;
    }).catch(()=>{return false;});
  }

  // SKU一括入力プロパティ
  public sbaoiHeaderItem: Common.SalesOrderItem = new Common.SalesOrderItem();
  public scheduledDeliveryDateSKU: Date = new Date();
  // SKU一括入力ダイアログを表示
  public showSkuBundleAddOrderItem() {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;    
    this.sbaoiHeaderItem = new Common.SalesOrderItem();
    this.sbaoiHeaderItem.taxCode = parent.counterpart.taxCode; //税区分初期値をセット
    this.scheduledDeliveryDateSKU = new Date();
    (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).items = new Array();
    (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).showDialog();
  }
  
  // 定期出荷入力プロパティ
  public regdOrderItems: Common.SalesOrderItem = new Common.SalesOrderItem();
  public regdWorkflowRequired: boolean = false;
  public regdWorkflowId: number = 0;
  public regdPic: string = '';
  public regdRefNo: string = '';
  public regdRegularlyStartMonth: Date = null;
  public regdRegularlyDate: number = 0;
  public regdRegularlySycle: number = 0;
  public regdRegularlyTimes: number = 0;
  public buttonNames: Array<string> = null;
  public buttonIndexIdArray: Array<{index:number,actionId:number}> =null;
  public roundDown: Common.RoundTypes = Common.RoundTypes.RoundDown;  // 定期出荷可能数量計算用
  // 定期出荷入力ダイアログを表示
  public showRegularlyDeliveryDialog() {

    this.getCheckedOrders();
    if(this.checkedOrders.length == 0){
      this.$api.modal.show('', '受注伝票を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrders.length > 1){
      this.$api.modal.show('', '単一の受注伝票を選択してください', true, null);
      return ;
    }
    if(this.checkedOrders[0].state < Common.OrderStatus.SalesOrderItemsOperateWaiting){
      this.$api.modal.show('', '「出荷処理待ち」か「出荷処理中」の受注伝票を選択してください。', true, null);
      return ;
    }
    
    var items:Array<Common.SalesOrderItem>;
    items = new Array();
    this.allSalesOrderItems().forEach(item => {
      if(item.commodity.isNoStock == true && item.backSalesOrderQuantity > 0) items.push(item);
    });
    if(items.length<1){
      this.$api.modal.show('', '定期出荷できる明細がありません。棚卸対象外の商品で受注残数量のある明細がある受注伝票を選択して下さい。', true, null);
      return ;
    }

    this.regdWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_salesDelivery');
    this.onChangeregdWorkflow();
    this.regdPic = this.$api.auth.userId;
    this.regdOrderItems = new Common.SalesOrderItem();
    (this.$refs.regularlyDeliveryDialog as Components.ListDialog).items = items;
    (this.$refs.regularlyDeliveryDialog as Components.ListDialog).showDialog();
  }
  public submitRegularlyDeliveryQuery(list: Array<Common.OrderItem>, index:number){
    var query: Common.RegularlyDeliveryQuery =new Common.RegularlyDeliveryQuery();
    query.salesOrderItems = list;
    query.workflowId = this.regdWorkflowId;
    query.pic = this.regdPic;
    query.deliveryRefNo = this.regdRefNo;
    query.regularlyStartMonth = this.regdRegularlyStartMonth;
    query.regularlyDate = this.regdRegularlyDate;
    query.regularlySycle = this.regdRegularlySycle;
    query.regularlyTimes = this.regdRegularlyTimes;
    query.actionId = this.buttonIndexIdArray.filter(obj => obj.index==index)[0].actionId;

    (this.$refs.regularlyDeliveryDialog as Components.ListDialog).closeDialog();
    return this.$api.execute(query,true).then(res => {
      // 画面を更新
      (this.$refs.mainList as Components.ListView).reload();
      //トライアル中はロードマップを更新
      if(this.$api.license.isTrial) this.$api.updateRoadmapRatio();     
      var deliveries = res as Common.Delivery[];
      var links = deliveries.map(delivery=>new Common.ModalLink(delivery.deliveryNo,String.format('/sales/SalesDelivery?deliveryNo={0}',delivery.deliveryNo)));
      var dialogMessage = '以下の出荷伝票が作成されました。';
      if(deliveries.length==1){
        this.$api.modal.show('処理結果',dialogMessage,false,()=>{
          var url = String.format('/sales/SalesDelivery?deliveryNo={0}',deliveries[0].deliveryNo);
          if (url){ this.$router.push(url);}
        },links,'伝票に移動する','閉じる');
      }else{
        this.$api.modal.show('処理結果',dialogMessage,true,null,links,'閉じる');
      }
      return true;
    }).catch(()=>{
      return false;}); 
  }

  public onChangeregdWorkflow(){
    this.buttonNames=new Array();
    this.buttonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.buttonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.buttonNames.push("出荷保存");
    if(this.regdWorkflowId!=0)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('salesDelivery', this.regdWorkflowId, Common.DeliveryStatus.SalesDeliveryPostWaiting);
      actions.forEach(action => {
        this.buttonNames.push(action.actionName);
        this.buttonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }
  }

  // 商品変更時に連動更新項目をサーバー側で行いそれを設定する
  public onChangeCommodity2(){
    // 明細を初期化
    (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).items = new Array(0);
    
    // 商品に連動する項目の設定
    this.sbaoiHeaderItem.onChangeCommodity(this.tenantSettings);
    this.getPriceAndTaxCode(this.sbaoiHeaderItem);
    
    if(this.sbaoiHeaderItem != null && this.sbaoiHeaderItem.commodity != null){
      // 選択した商品のSKUを一括取得
      var query = new Common.SKUMasterQuery();
      query.commodityId = this.sbaoiHeaderItem.commodity.id;
      this.$api.execute(query).then(res => {
        // SKUごとに明細を作成
        for(var sku of res.result){
          var item = (this.sbaoiHeaderItem as Common.StateObject2).copy();
          item.sku = sku as Common.SKU;
          this.getPriceAndTaxCode(item);
          (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).items.push(item);
        }
      });
      // 明細を更新
      (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).$forceUpdate();
    }
  }

  // 単位変更時に単価・税区分を取得する
  public onChangePackage(){
    for(var item of (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).items){
      item.package = this.sbaoiHeaderItem.package;
      this.getPriceAndTaxCode(item);
    }
  }

  // SKU一括入力の実行
  public async submitSkuBundleAddOrderItemQuery(list: Array<Common.SalesOrderItem>) {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;
    var items = new Array();
    for(var obj of list){
      if(obj.quantity == 0) continue;
      obj.order = parent;
      // ダイアログのヘッダ部の内容を設定
      obj.commodity = this.sbaoiHeaderItem.commodity;
      obj.commodityName = this.sbaoiHeaderItem.commodityName;
      // obj.package = this.sbaoiHeaderItem.package;
      obj.uom2 = this.sbaoiHeaderItem.uom2;
      obj.taxCode = this.sbaoiHeaderItem.taxCode;
      obj.supplier = this.sbaoiHeaderItem.supplier;
      obj.scheduledDeliveryDate = this.scheduledDeliveryDateSKU;
      items.push(obj);
    }

    if(items.length == 0){
      return this.$api.modal.showDialog('', 'いずれかの行で受注数量を指定して下さい。').then(()=>false);      
    }
    //新規追加時は明細を一時的に保持する
    if((this.$refs.mainList as Components.ListView).isInsertMode){
     (this.$refs.salesOrderItems as Components.GrdVoucherItem).mergeItems(items);
      return true;
    }
    var query = new Common.BundleAddOrderItemQuery(Common.SalesPurchaseFlags.Sales);
    query.orderItems = items;
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/sales/SalesOrderItem?orderNo={0}',parent.orderNo));
    // });
    return this.$api.execute(query).then(res => {
      //受注金額が更新されるのでリストを更新する
       (this.$refs.mainList as Components.ListView).onSubmit(res);
      //受注明細タブのリロード
       (this.$refs.salesOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();       
      this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      return true;
    }).catch(()=>{return false;});    
  }

  // 入金情報タブ更新用プロパティ
  public isLoading:boolean = false;
  public totalPaymentAmountFC:number = 0;
  public totalPaymentAmount:number = 0;
  public totalPendingAmountFC:number = 0;
  public paymentJournals: Common.TransferJournal[]= new Array(0);

  // 入金情報タブを更新
  public refreshPaymentList(){
    this.isLoading = true;
    var totalWriteoffAmountFC = 0;
    var totalWriteoffAmount = 0;
    var totalWriteoffPendingAmountFC = 0;
    // クエリの設定
    var query = new Common.PaymentJournalQuery();
    query.voucherNo = (this.$refs.mainList as Components.ListView).selected.orderNo;
    query.isSend = false;

    // サーバーから入金情報を取得する
    this.$api.execute(query).then(res => {
      if((this.$refs.mainList as Components.ListView).isInsertMode == false){
        res = res as Common.LoadResult;
        this.paymentJournals = res.result;
        this.paymentJournals.forEach((obj, index) => {
          if (obj.isPosted) {
            totalWriteoffAmountFC += obj.amountFC;
            totalWriteoffAmount += obj.debitAmount;
            obj.state = Common.PaymentStatus.ReceiptCompleted;
          } else {
            totalWriteoffPendingAmountFC += obj.amountFC;
            obj.state = Common.PaymentStatus.ReceiptPostWaiting;            
          }
        });
      }
    }).finally(()=>{
      this.isLoading = false;
      this.totalPaymentAmountFC = totalWriteoffAmountFC;
      this.totalPaymentAmount = totalWriteoffAmount;
      this.totalPendingAmountFC = totalWriteoffPendingAmountFC;
    });
  }

  // 入金一覧へ遷移する
  public onPaymentNoClick(paymentNo: string){
    this.$router.push(String.format('/cash/Deposit?paymentNo={0}',paymentNo));
  }
  // 発注処理ダイアログの表示
  public showCreatePurchaseOrderDialog(all:boolean = false, bulk:boolean = false) {

  
// ***** 一括発注処理の押下確認 *****
if(all==false && bulk == true){
this.$api.issueGA4trackevent(this.$route.path,'【受注一覧】一括発注処理・押下');
}
    let componentClass = Vue.extend(this.createPurchaseOrder);    
    var router = this.$router;
    this.getCheckedOrders();
    let instance = new componentClass({
        router,
        propsData: {
          checkedOrderItems: bulk ? null : all ? this.allSalesOrderItems() : this.selectedSalesOrderItems(),
          isBulkOrder: bulk,
          checkedOrders: bulk ? this.checkedOrders : null,
          salesOrderItems: this.$refs.salesOrderItems,
          parentMainList: this.$refs.mainList,
          parent: this,
          isItemFlag: false,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }
  // 出荷指示ダイアログの表示
  public showShippingInstructionDialog(all = false, selectedOrder = false){
    var orders = new Array();
    // 業務処理の一括出荷の場合、選択されている受注伝票を取得
    if(selectedOrder == true){
      this.getCheckedOrders();
      if(this.checkedOrders.length == 0){
        this.$api.modal.show('', '受注伝票を選択して下さい。', true, null);
        return;
      }
      orders = this.checkedOrders.filter(obj => obj.state >= Common.OrderStatus.SalesOrderReceiptWaiting && obj.state < Common.OrderStatus.SalesOrderCompleted);
      if(orders.length == 0){
        this.$api.modal.show('', '「出荷処理待ち」か「出荷処理中」の受注伝票を選択してください。', true, null);
        return ;
      }
      if(orders.filter(obj => obj.segment.priceCalculationMethod==Common.PricingTypes.Specific).length>0){
        this.$api.modal.show('', '在庫単価計算が個別法の部門では、明細ごとに処理を行ってください。', true, null);
        return ;
      }
    }
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;
    let componentClass = Vue.extend(this.shippingInstructionDialog);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          execOrder: selectedOrder,
          orderNos: orders.map(obj=>obj.orderNo),
          checkedOrderItems: selectedOrder ? null : all ? this.allSalesOrderItems() : this.selectedSalesOrderItems(),
          parentMainList: this.$refs.mainList,
          salesOrderItems: this.$refs.salesOrderItems,
          tenantSettings: this.tenantSettings, 
          counterpart: parent.counterpart,
          parent: this,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);

  }
  
  // 明細クローズ処理ボタンの活性判別
  public  enabledOrderItemCloseFuncButton(order:Common.SalesOrder):boolean{
    return order.state >= Common.OrderStatus.SalesOrderReceiptWaiting && order.state < Common.OrderStatus.SalesOrderCompleted;
  }
  // 明細クローズ解除処理ボタンの活性判別
  public  enabledOrderItemCloseCancelFuncButton(order:Common.SalesOrder):boolean{
    return order.state >= Common.OrderStatus.SalesOrderReceiptWaiting;
  }
  // 明細クローズ処理
  public async itemClosedQuery(isClose:boolean) {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;

    var selectedItems:Array<Common.SalesOrderItem>;
    selectedItems = this.selectedSalesOrderItems();
    if(selectedItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
      return;
    }
    var targetItems:Array<Common.SalesOrderItem>;
    targetItems=new Array();
    // クローズ処理：注残あり、クローズ解除処理：クローズ数量あり
    if(isClose == true){
      selectedItems.forEach(item =>{
        if(item.backSalesOrderQuantity > 0) targetItems.push(item);
      });
      if(targetItems.length<1){
        this.$api.modal.show('', '受注残数量のある明細を選択して下さい。', true, null);
        return ;
      }
    }else{
      selectedItems.forEach(item =>{
        if(item.closedQuantity > 0) targetItems.push(item);
      });
      if(targetItems.length<1){
        this.$api.modal.show('', 'クローズ数量のある明細を選択して下さい。', true, null);
        return ;
      }
    }
    return this.$api.modal.showDialog('確認',String.format('選択された受注明細の{0}を0にします。よろしいですか？',isClose?'受注残数量':'クローズ数量'),false).then(()=>{
      var query = new Common.OrderItemCloseQuery();
      query.orderItems = targetItems;
      query.isClose = isClose;
      return this.$api.execute(query).then(res =>{
        //受注残・ステータスが更新されるのでリストを更新する
        (this.$refs.mainList as Components.ListView).onSubmit(res);
        //受注明細タブのリロード
        (this.$refs.salesOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();      
        this.$api.modal.show('処理結果','処理が完了しました。',true,null);
        return true;
      }).catch(()=>{return false;});;
    });
  }

  showSubscriptionDateUpdate:boolean = false;
  subscriptionStartDate: Date = null;
  subscriptionEndDate: Date = null;  
  public showSubscriptionDateUpdateDialog(){

    var selectedItems = this.selectedSalesOrderItems();
    if(selectedItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
      return;
    }
    this.subscriptionStartDate = null;
    this.subscriptionEndDate = null;

    this.showSubscriptionDateUpdate = true;
  }

  public showUpdateDeliveryDateDialog(){
    let componentClass = Vue.extend(this.updateDeliveryDate);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          checkedOrderItems: this.selectedSalesOrderItems(),
          parentMainList: this.$refs.mainList,
          gridVoucherItem: this.$refs.salesOrderItems,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }

  public onSubscriptionDateUpdate(event: any){
    if (this.subscriptionStartDate == null && this.subscriptionEndDate == null){
      this.$api.modal.showDialog('', '契約開始日もしくは契約完了日のいずれかを指定してください。', true, null).then(()=>{
        this.showSubscriptionDateUpdate = true;
      });
      return;      
    }

    var selectedItems = this.selectedSalesOrderItems();
    return this.$api.execute(new Common.OrderItemSubscriptionUpdateQuery(selectedItems,this.subscriptionStartDate,this.subscriptionEndDate)).then(res =>{
      //受注残・ステータスが更新されるのでリストを更新する
      (this.$refs.mainList as Components.ListView).onSubmit(res);
      //受注明細タブのリロード
      (this.$refs.salesOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();      
      this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      return true;
    }).catch(()=>{return false;});;    
  }

  // 個別帳票出力
  public showCustomerReport(isMail: boolean = false){
    this.getCheckedOrders();
    this.checkedOrders.forEach(item =>{ item.designationReportTemplateId = item.counterpart.salesOrderReportTemplateId;});
    if (isMail) (this.$refs.menuBar as Components.ListViewMenuBar).beforeDesignationReportSend(); // 得意先指定帳票メール送信前処理
    else (this.$refs.menuBar as Components.ListViewMenuBar).onDesignationReportGenerate();
  //   if(this.checkedOrders.length > 1){
  //     this.$api.modal.show('', '単一の伝票を選択してください。', true, null);
  //     return ;
  //   }
  //   var templates = (this.$refs.menuBar as Components.ListViewMenuBar).reports;
  //   var template = templates.filter(obj => obj.id == this.checkedOrders[0].counterpart.salesOrderReportTemplateId)[0];
  //   if(template==null){
  //     this.$api.modal.show('', '受注一覧指定帳票が指定されていません。取引先マスタで受注一覧指定帳票を設定してください。', true, null, [new Common.ModalLink('設定の方法はこちら','https://support.s-flow.net/ja/articles/8159389',true)]);
  //     return ;
  //   }
  //   var query = new Common.ReportQuery2(template.queryName, this.checkedOrders);
  //   query.templateId = template.id;
  //   this.$api.download(query); 
  }
  public get orderGrossProfit() : number { return this.isLoading ? null : this.calcOrderGrossProfit;}
  public set orderGrossProfit(value: number) {}
  public calcOrderGrossProfit : number = 0;
  public afterVoucherNoChanged(){
    this.calcOrderGrossProfit = 0;
    var items =  (this.$refs.salesOrderItems as Components.GrdVoucherItem).items as Common.OrderItem[];
    items.forEach(obj => this.calcOrderGrossProfit += obj.calcGrossProfit);
  }
}

</script>

<style lang="scss">
// .cx_link_item {
//   &:hover {
//     font-weight: bolder;
//     color: #007de4 !important; 
//   }
// }


</style>